/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import { createAction } from '../../../modules/app/createAction';
import {
    CACHE_USER_DATA_START,
    CACHE_USER_DATA_START_FAILURE,
    CACHE_USER_DATA_START_SUCCESSFUL,
    CHECK_USER_DATA_CACHE,
} from '../constants/authCacheConstants';
import {
    ICacheUserDataStart,
    ICacheUserDataStartFailure,
    ICacheUserDataStartSuccessful,
    ICheckUserDataCache,
} from '../types/authCacheTypes';

/**
 * Initiate asynchronous procedure of loading user data to cache
 */

/**
 * @description Start action
 * @returns {ICacheUserDataStart}
 */
export const cacheUserDataStart = (): ICacheUserDataStart =>
    createAction(CACHE_USER_DATA_START);

/**
 * @description Successful execution of action
 * @returns {ICacheUserDataStart}
 */
export const cacheUserDataStartSuccessful = (): ICacheUserDataStartSuccessful =>
    createAction(CACHE_USER_DATA_START_SUCCESSFUL);

/**
 * @description Failure execution of action
 * @returns {ICacheUserDataStart}
 */
export const cacheUserDataStartFailure = (payload: string): ICacheUserDataStartFailure =>
    createAction(CACHE_USER_DATA_START_FAILURE, payload);

/**
 * @description Check is current user data already loaded into cache
 * @returns {ICheckUserDataCache}
 */
export const checkUserDataCache = (payload: boolean): ICheckUserDataCache =>
    createAction(CHECK_USER_DATA_CACHE, payload);
/**
 * Common type for historyOrder reducer
 */
export type UserInfoTypes =
    ICacheUserDataStart
    | ICacheUserDataStartFailure
    | ICacheUserDataStartSuccessful
    | ICheckUserDataCache
